module.exports = __webpack_public_path__ + "static/media/carousel-financeiro.6ad419b1.png";